var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0)",
    fill: "#4C6FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 80.4066H70.619C50.4286 80.4066 63 62.6926 39 63.8355M79 80.4066L69.8571 88.9781M79 80.4066L69.8571 71.8352",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47.211H70.619C50.4286 47.211 63 64.925 39 63.7822M79 47.211L69.8571 38.6396M79 47.211L69.8571 55.7825",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventSplit);
export default __webpack_public_path__ + "static/media/canvas_event_split.0da69ca6954a7fbcda3fea2aba2b3bf5.svg";
export { ForwardRef as ReactComponent };